import PropTypes from "prop-types";
import React, { Component } from "react";
import Dialog from "./dialog";
import Button from "components/form/flat-button";
import Globalize from "globalize";
import { DATATEST } from "constants/integration";

/** @augments {Component<any, any>} */
export class ConfirmDialog extends Component {
    static propTypes = {
        open: PropTypes.bool.isRequired,
        onConfirm: PropTypes.func,
        onCancel: PropTypes.func.isRequired,
        contentStyle: PropTypes.object,
        style: PropTypes.object,
        dataTestConfirm: PropTypes.string,
        dataTestCancel: PropTypes.string,
        confirmLabel: PropTypes.string,
        cancelLabel: PropTypes.string,
        disabledConfirm: PropTypes.bool,
        hideCancelButton: PropTypes.bool,
        hideConfirmButton: PropTypes.bool,
    };

    render() {
        const {
            // eslint-disable-next-line react/prop-types
            children,
            onConfirm,
            onCancel,
            contentStyle,
            dataTestConfirm,
            dataTestCancel,
            cancelLabel,
            confirmLabel,
            disabledConfirm,
            hideCancelButton = false,
            hideConfirmButton = false,
            ...props
        } = this.props;
        return (
            <Dialog
                {...props}
                modal={true}
                onRequestClose={onCancel}
                contentStyle={Object.assign({ maxWidth: "360px" }, contentStyle)}
                actions={[
                    ...(!hideCancelButton
                        ? [
                              <Button
                                  key="cancel"
                                  data-test={dataTestCancel || DATATEST.DIALOG.CANCEL}
                                  label={cancelLabel || Globalize.formatMessage("Cancel")}
                                  style={{ marginRight: !hideConfirmButton ? "24px" : 0 }}
                                  onClick={onCancel}
                              />,
                          ]
                        : []),
                    ...(!hideConfirmButton
                        ? [
                              <Button
                                  key="confirm"
                                  disabled={disabledConfirm || false}
                                  data-test={dataTestConfirm || DATATEST.DIALOG.CONFIRM}
                                  label={confirmLabel || Globalize.formatMessage("Confirm")}
                                  primary={true}
                                  onClick={onConfirm}
                              />,
                          ]
                        : []),
                ]}
            >
                {children}
            </Dialog>
        );
    }
}

export default ConfirmDialog;
